import Intents from '@ux/intents';

const intents = new Intents();
export const theme = {
  ...intents,
  sectionTitle: {
    fontStyle: 'normal',
    fontWeight: 850,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    color: '#004249'
  }
};

export type Theme = { [P in keyof typeof theme]: typeof theme[P] | any };
